/**
 * Client-side queue helpers for beer duplicate review (ITT-922).
 */

export function buildBeerDuplicateReviewPath(reviewId) {
  if (!reviewId) {
    return '/beer?tab=dupes';
  }
  return `/beer/dupes/review/${reviewId}`;
}

export function buildBeerDuplicateInboxPath() {
  return '/beer?tab=dupes';
}

export function queueReviewIdsFromRows(rows) {
  if (!Array.isArray(rows)) {
    return [];
  }
  return rows
    .map((row) => row?.id)
    .filter((reviewId) => typeof reviewId === 'string' && reviewId.length > 0);
}

export function queueIndexForReview(reviewId, queueReviewIds) {
  if (!reviewId || !Array.isArray(queueReviewIds)) {
    return -1;
  }
  return queueReviewIds.indexOf(reviewId);
}

export function resolveQueueNeighbors(reviewId, queueReviewIds) {
  const currentIndex = queueIndexForReview(reviewId, queueReviewIds);
  if (currentIndex < 0) {
    const firstRemaining = Array.isArray(queueReviewIds) ? queueReviewIds[0] : null;
    return {
      currentIndex,
      previousReviewId: null,
      nextReviewId: firstRemaining || null,
      positionLabel: queueReviewIds?.length ? `— of ${queueReviewIds.length}` : '',
    };
  }
  return {
    currentIndex,
    previousReviewId: currentIndex > 0 ? queueReviewIds[currentIndex - 1] : null,
    nextReviewId: currentIndex < queueReviewIds.length - 1
      ? queueReviewIds[currentIndex + 1]
      : null,
    positionLabel: `${currentIndex + 1} of ${queueReviewIds.length}`,
  };
}

export function nextQueuedReviewIdAfter(appliedReviewId, previousQueueIds, refreshedQueueIds) {
  const previousIds = Array.isArray(previousQueueIds) ? previousQueueIds : [];
  const refreshedIds = Array.isArray(refreshedQueueIds) ? refreshedQueueIds : [];
  const refreshedSet = new Set(refreshedIds);
  const appliedIndex = previousIds.indexOf(appliedReviewId);
  const startIndex = appliedIndex >= 0 ? appliedIndex + 1 : 0;
  for (let index = startIndex; index < previousIds.length; index += 1) {
    const candidateId = previousIds[index];
    if (refreshedSet.has(candidateId)) {
      return candidateId;
    }
  }
  return null;
}

export { isEditableKeyboardTarget } from '../brewery/beerIngestionReviewQueue';
